import React from "react";
import { ViewTypesEnum } from "../../../../Enums";
import {NoContentComponent } from '../../../../Components' ; 
import { VendorsCards } from "../VendorsViewComponent/VendorsCards";
import { VendorsTableComponent  } from "../VendorsUtilities";

export const VendorsContentView = ({
        parentTranslationPath , 
        translationPath , 
        activeActionType , 
        pathName , 
        reloadData ,
        checkedCards ,
        setCheckedCards , 
        checkedCardsIds , 
        detailedCardActionClicked ,
        vendorsTableFilter , 
        onFilterValuesChanged , 
        setCheckedCardsIds ,
        setFilter , 
        activeSelectedAction , 
        filter , 
        detailedCardSideActionClicked ,
        closeSideMenu , 
        onRowClicked ,
        isFirst ,
        detailsVendorsList ,
        activeCard ,
        isExpanded ,
        onCardClick ,
        setActiveCard , 
        dispatch ,
        setOrderBy ,
        isClearFiltersClicked ,
        setIsClearFiltersClicked ,
        displayOpenFileButton ,
        formId ,
        sideMenuIsOpenUpdate ,
        loginResponse ,
        advanceSearchBtn ,
        cardCheckboxClicked ,
        setAdvanceSearchBtn  ,
        allFormFields ,
        isAllFormFieldsLoading 
}) => {
  return (
    <>
      {detailsVendorsList && detailsVendorsList.totalCount === 0 && activeActionType === ViewTypesEnum.cards.key &&  (
        <NoContentComponent />
      )}
      {(activeActionType === ViewTypesEnum.tableView.key && 
         (
          <div className="pr-3">
            <VendorsTableComponent
              filter={filter}
              pathName={pathName}
              reloadData={reloadData}
              checkedCards={checkedCards}
              setCheckedCards={setCheckedCards}
              checkedCardsIds={checkedCardsIds}
              onActionClicked={detailedCardActionClicked}
              vendorsTableFilter={vendorsTableFilter}
              onFilterValuesChanged={onFilterValuesChanged}
              setCheckedCardsIds={setCheckedCardsIds}
              setFilter={setFilter}
              detailsVendorsList={detailsVendorsList}
              activeSelectedAction={activeSelectedAction}
              translationPath={translationPath}
              parentTranslationPath={parentTranslationPath}
              setOrderBy={setOrderBy}
              isClearFiltersClicked={isClearFiltersClicked}
              setIsClearFiltersClicked={setIsClearFiltersClicked}
              displyOpenFileButton={displayOpenFileButton}
              formId={formId}
              setActiveCard={setActiveCard}
              sideMenuIsOpenUpdate={sideMenuIsOpenUpdate}
              loginResponse={loginResponse}
              detailedCardSideActionClicked={detailedCardSideActionClicked}
              closeSideMenu={closeSideMenu}
              onRowClick={onRowClicked}
              isFirst={isFirst}
              activeActionType={activeActionType}
              allFormFields={allFormFields}
              isAllFormFieldsLoading={isAllFormFieldsLoading}
            />
          </div>
        )) ||
        (activeActionType === ViewTypesEnum.cards.key &&
          detailsVendorsList &&
          detailsVendorsList.totalCount > 0 && (
            <>
              <div className="view-wrapers">
                <VendorsCards
                  data={detailsVendorsList}
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                  activeCard={activeCard}
                  isExpanded={isExpanded}
                  onCardClicked={onCardClick}
                  onFooterActionsClicked={detailedCardSideActionClicked}
                  onActionClicked={detailedCardActionClicked}
                  onCardCheckboxClick={cardCheckboxClicked}
                  selectedCards={checkedCards}
                  displyOpenFileButton={displayOpenFileButton}
                  activeAction={activeSelectedAction}
                  setActiveCard={setActiveCard}
                  reloadData={reloadData}
                  setAdvanceSearchBtn={setAdvanceSearchBtn}
                  loginResponse={loginResponse}
                  formId={formId}
                  advanceSearchBtn={advanceSearchBtn}
                  closeSideMenu={closeSideMenu}
                  displayOpenFileButton={true}
                  dispatch={dispatch}
                />
              </div>
            </>
          ))}
    </>
  );
};
